import { render, staticRenderFns } from "./productOrderCraftInfo.vue?vue&type=template&id=3d388b9c&scoped=true&"
import script from "./productOrderCraftInfo.vue?vue&type=script&lang=js&"
export * from "./productOrderCraftInfo.vue?vue&type=script&lang=js&"
import style0 from "./productOrderCraftInfo.vue?vue&type=style&index=0&id=3d388b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d388b9c",
  null
  
)

export default component.exports